import { render, staticRenderFns } from "./tab-input.vue?vue&type=template&id=0af90346&"
import script from "./tab-input.vue?vue&type=script&lang=js&"
export * from "./tab-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports